import React from 'react'
import { EntityDetailLayout } from 'components/EntityDetailPage/EntityDetailLayout'
import { CompanySidebarNew } from './Sidebar/CompanySidebarNew'
import type { CompanySidebarHeader, SidebarTabConfig } from './Sidebar'
import { useDynamicCategoryInfo } from 'context/layout'
import type { BreadcrumbItem } from 'components/Layout/Header/types'

interface CompanyPageLayoutNewProps {
  chainProxyId: number
  sidebar: {
    header: CompanySidebarHeader
    tabs: SidebarTabConfig[]
  }
  doorId?: number
  address?: string
  phone?: string
  children?: React.ReactNode
  /** Entity breadcrumbs for new navigation header */
  entityBreadcrumbs?: BreadcrumbItem[]
  /** Dynamic category info for unmatched/user-generated pages */
  categoryInfo?: {
    categorySlug: string
    subCategorySlug: string
  }
}

/**
 * Company page layout with sidebar and entity breadcrumbs.
 *
 * Wraps EntityDetailLayout with company-specific sidebar and dynamic
 * category info support.
 */
export function CompanyPageLayoutNew(props: CompanyPageLayoutNewProps) {
  const { chainProxyId, entityBreadcrumbs, categoryInfo } = props

  useDynamicCategoryInfo(
    categoryInfo?.categorySlug,
    categoryInfo?.subCategorySlug
  )

  return (
    <EntityDetailLayout
      gap={6}
      contentGap={6}
      className="gap-y-4"
      contentClassName="pb-0"
      // FBPage's default bg is `#f5f5f5`, which isn't a Tailwind gray.
      // Override to bg-gray-50 (#f9fafb) so the page background matches the
      // deal detail page and uses a value from the standard Tailwind palette.
      innerPageClassName="!bg-gray-50"
      entityBreadcrumbs={entityBreadcrumbs}
      sidebar={
        <CompanySidebarNew
          chainProxyId={chainProxyId}
          {...props.sidebar}
          doorId={props.doorId}
          address={props.address}
          phone={props.phone}
        />
      }
    >
      {props.children}
    </EntityDetailLayout>
  )
}
